@if (this.tickets.length === 0) {
  <app-not-found header="Geen meldingen gevonden">
    Begin nu met het melden van een probleem of stel je vraag. Klik op de knop hieronder om een nieuwe melding aan te
    maken.
    <app-button ngProjectAs="[button]" routerLink="/dashboard/customersupport/tickets/new">Nieuwe melding</app-button>
  </app-not-found>
} @else {
  <div class="grid-desktop-1 grid-mobile-1 grid-tablet-1 text-right">
    <app-button [disabled]="this.getOpenTickets().length >= config.maxTicketsPerRelation"
      routerLink="/dashboard/customersupport/tickets/new">Nieuwe melding
    </app-button>
  </div>
  <div class="grid-desktop-2 grid-mobile-1 grid-tablet-1 full-height">
    @for (ticket of this.tickets; track ticket) {
      <app-card [header]="ticket.ticket_id">
        <app-badge ngProjectAs="[badge]" size="small" icon="ticket"></app-badge>
        <span class="text-clamped-3"> {{ ticket?.messages[0]?.description ?? '' }} </span>
        <ul>
          @if (ticket.subscr_id) {
            <li>
              <span>Abonnement:</span>
              <span>{{ ticket.subscr_id }}</span>
            </li>
          }
          <li>
            <span>Laatste update:</span>
            <span>{{ ticket.updated_at | date }}</span>
          </li>
          <li>
            <span>Status:</span>
            <span>{{ TicketStateLabel[ticket.state_description] }}</span>
          </li>
        </ul>
        <app-button ngProjectAs="[button]" [routerLink]="['/dashboard/customersupport/tickets/', ticket.ticket_id]"
          type="outline">
          Bekijken
        </app-button>
      </app-card>
    }
  </div>
}

